import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { requestCanceller } from './../../service/axiosCancelToken';
import { useHistory } from 'react-router-dom';
import { adminLoginValidator } from './../../service/validatorForms';
import { getCaptcha } from './../../service/captchaService';
import { decrypt } from '../../service/cryptography';
import { useToasts } from 'react-toast-notifications';
import { adminLogin } from './../../service/adminService';
import { htmlToJsx } from './../../service/reactHtmlParser';
import './Login.css';
import LoadingSpinner from './../shared/LoadingSpinner';
import { digitsArToEn, digitsFaToEn } from '@persian-tools/persian-tools';

const Login = () => {
    const { addToast } = useToasts()
    const [captcha, setCaptcha] = useState();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [code, setCode] = useState("");
    const [getForceUpdate, setForceUpdate] = useState();
    const forceUpdate = useCallback(() => setForceUpdate({}), []);
    const [forceUpdate2, setForceUpdate2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    let history = useHistory();
    const validatorRef = useRef(adminLoginValidator());


    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchCaptcha = async () => {
            try {
                let { status, data } = await getCaptcha({ cancelToken: cancelRequest.signal });
                if (status === 201) {
                    let captcha = decrypt(data.captcha);
                    setCaptcha({
                        data: captcha.data,
                        text: captcha.text,
                    });
                }
            } catch (err) { }
        };
        fetchCaptcha();
        return () => {
            cancelRequest.cancel();
        }
    }, [getForceUpdate]);

    const submitHandler = async (event) => {
        event.preventDefault();
        try {
            if (validatorRef.current.allValid()) {
                if (String(code).toUpperCase() !== String(captcha.text).toUpperCase()) {
                    validatorRef.current.hideMessageFor("code");
                    setCode("");
                    forceUpdate();
                    addToast("حاصل جمع اشتباه است", {
                        appearance: 'error',
                        autoDismiss: true,
                    })
                    return;
                }
                setIsLoading(true);
                const { status, data } = await adminLogin(email, password);
                if (status === 201) {
                    addToast('ورود به پنل مدیریت انجام شد', {
                        appearance: 'success',
                        autoDismiss: true,
                    })
                    localStorage.setItem("token", data.token);
                    history.replace("/dashboard", data.adminId);
                }
            } else {
                validatorRef.current.showMessages();
                forceUpdate();
            }
        } catch (err) {
            if (err.response && err.response.status === 422)
                addToast("اطلاعات را به طور کامل وارد کنید", {
                    appearance: 'error',
                    autoDismiss: true,
                })
            else if (err.response && err.response.status === 401) {
                addToast("ایمیل و یا رمز عبور اشتباه است", {
                    appearance: 'error',
                    autoDismiss: true,
                })
            }
            validatorRef.current.hideMessageFor("email");
            validatorRef.current.hideMessageFor("password");
            validatorRef.current.hideMessageFor("code");
            setEmail("");
            setPassword("");
            setCode("");
            forceUpdate();
        }
        setIsLoading(false);
    };
    return (
        <div className="rtl admin-login-layout" >

            <div className=" container pt-5" >
                <div className=" login-form col-xl-4 col-lg-5 col-md-6 col-sm-10 pt-3 pb-5 px-5  mx-auto" >
                    <form onSubmit={submitHandler} className="mx-auto" autoComplete="off">
                        <header>
                            <h5 className="mx-auto text-center my-3">ورود به پنل مدیریت</h5>
                        </header>
                        <Helmet>
                            <title>3 دان | ورود به پنل مدیریت</title>
                        </Helmet>
                        {
                            !captcha ?
                                <div style={{ height: '55vh' }} className="d-flex">
                                    <div className="text-center align-self-center mx-auto">
                                        <LoadingSpinner />
                                    </div>
                                </div> :
                                <React.Fragment>
                                    <div className="form-group">
                                        <label htmlFor="email">آدرس ایمیل:</label>
                                        <input
                                            type="email"
                                            name="email"
                                            id="emlil"
                                            className="form-control ltr"
                                            placeholder=""
                                            value={email}
                                            onChange={(e) => setEmail(digitsFaToEn(digitsArToEn(e.target.value)))}
                                            onBlur={() => {
                                                if (email !== '') {
                                                    validatorRef.current.showMessageFor("email");
                                                    setForceUpdate2(!forceUpdate2)
                                                }
                                            }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        />
                                        {validatorRef.current.message(
                                            "email",
                                            email,
                                            "required|email"
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="pwd">کلمه عبور :</label>
                                        <input
                                            type="password"
                                            className="form-control ltr"
                                            placeholder=""
                                            value={password}
                                            onChange={(e) => setPassword(digitsFaToEn(digitsArToEn(e.target.value)))}
                                            onBlur={() => {
                                                if (password !== '') {
                                                    validatorRef.current.showMessageFor("password");
                                                    setForceUpdate2(!forceUpdate2)
                                                }
                                            }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        />
                                        {validatorRef.current.message(
                                            "password",
                                            password,
                                            "required|min:6|max:25"
                                        )}
                                    </div>
                                    <div className="form-group ">
                                        <div className="mx-auto mb-2 text-center" >
                                            {
                                                captcha && htmlToJsx(captcha.data)
                                            }
                                        </div>
                                        <input type="text"
                                            placeholder="حاصل جمع"
                                            className="form-control text-center"
                                            value={code}
                                            onChange={(e) => setCode(digitsFaToEn(digitsArToEn(e.target.value)))}
                                            onBlur={() => {
                                                if (code !== '') {
                                                    validatorRef.current.showMessageFor("code");
                                                    setForceUpdate2(!forceUpdate2)
                                                }
                                            }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        />
                                        {validatorRef.current.message(
                                            "code",
                                            code,
                                            "required"
                                        )}

                                    </div>
                                </React.Fragment>

                        }
                        <button 
                            type="submit" 
                            className="btn btn-success btn-block mt-5"
                            disabled={isLoading}
                        >
                            <i
                                className={isLoading ? 'spinner-border spinner-border-sm mr-2' : ''}
                                style={{ position: 'relative', bottom: '2px' }}
                            ></i>
                            ورود
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;